import * as React from "react";

function HeroSvg(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      data-name="Layer 1"
      width="60%"
      height="60%"
      viewBox="0 0 842.17 568.852"
      {...props}
    >
      <path d="M538.17 568.852v-72.34s28.191 51.286 0 72.34z" fill="#f1f1f1" />
      <path
        d="M539.911 568.84l-53.29-48.922s56.846 13.916 53.29 48.922z"
        fill="#f1f1f1"
      />
      <path
        data-name="Rectangle 62"
        fill="#e5e5e5"
        d="M.359 23.079H842.17v399.454H.359z"
      />
      <path
        data-name="Rectangle 75"
        fill="#fff"
        d="M24.431 57.333h793.668V390.61H24.431z"
      />
      <path
        data-name="Rectangle 80"
        fill="#6ee7b7"
        d="M0 0h841.811v35.763H0z"
      />
      <circle
        data-name="Ellipse 90"
        cx={26.576}
        cy={17.815}
        r={6.628}
        fill="#fff"
      />
      <circle
        data-name="Ellipse 91"
        cx={51.736}
        cy={17.815}
        r={6.628}
        fill="#fff"
      />
      <circle
        data-name="Ellipse 92"
        cx={76.896}
        cy={17.815}
        r={6.628}
        fill="#fff"
      />
      <path
        data-name="Path 680"
        d="M154.46 133.203a3.268 3.268 0 000 6.536h89.293a3.268 3.268 0 100-6.536z"
        fill="#3f3d56"
      />
      <path
        data-name="Path 680"
        d="M103.96 178.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536zM103.96 204.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536zM103.96 230.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536zM103.96 256.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536zM103.96 282.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536zM103.96 308.203a3.268 3.268 0 000 6.536h190.293a3.268 3.268 0 100-6.536z"
        fill="#ccc"
      />
      <path
        d="M731.71 316.138H443.606a7.271 7.271 0 01-7.264-7.263V139.403a7.271 7.271 0 017.264-7.263h288.102a7.271 7.271 0 017.263 7.263v169.472a7.271 7.271 0 01-7.263 7.263z"
        fill="#f1f1f1"
      />
      <path
        d="M769.61 354.9H481.507a7.271 7.271 0 01-7.263-7.263V178.165a7.271 7.271 0 017.263-7.263H769.61a7.271 7.271 0 017.263 7.263v169.472a7.271 7.271 0 01-7.263 7.263z"
        fill="#fff"
      />
      <path
        d="M769.61 357.372H481.506a9.746 9.746 0 01-9.735-9.735V178.165a9.746 9.746 0 019.735-9.735h288.102a9.746 9.746 0 019.735 9.735v169.472a9.746 9.746 0 01-9.735 9.735zM481.506 173.373a4.797 4.797 0 00-4.792 4.792v169.472a4.797 4.797 0 004.792 4.792h288.102a4.797 4.797 0 004.792-4.792V178.165a4.797 4.797 0 00-4.792-4.792z"
        fill="#3f3d56"
      />
      <circle cx={625.17} cy={285.43} r={25} fill="#ff6583" />
      <path
        d="M673.398 261.379a16.099 16.099 0 00-23.025-.411l-81.08 81.08c-10.386 10.434-21.228-5.525-28.156-11.961-16.66-16.477-34.655 14.419-45.854 23.267h260.55v-3.317z"
        fill="#6ee7b7"
      />
      <path
        d="M352.23 359.66l-4.385-60.753 7.874-56.932-22.362-1.51-4.414 62.89 12.475 59.139a8.798 8.798 0 1010.811-2.833z"
        fill="#9f616a"
      />
      <path
        d="M330.504 248.648l5.25-22.726a17.497 17.497 0 0134.436 5.897l-2.892 25.68z"
        fill="#cbcbcb"
      />
      <path
        fill="#9f616a"
        d="M371.903 557.597h10.542l5.015-40.664-15.559.001.002 40.663z"
      />
      <path
        d="M369.213 554.155h20.762a13.232 13.232 0 0113.232 13.23v.43l-33.993.001z"
        fill="#2f2e41"
      />
      <path
        fill="#9f616a"
        d="M424.424 557.252l10.135-2.903-6.375-40.473-14.958 4.285 11.198 39.091z"
      />
      <path
        d="M420.891 554.684l19.96-5.718a13.232 13.232 0 0116.362 9.076l.119.413-32.679 9.361zM366.205 542.838l4.904-123.178-12.736-55.745c-17.139-28.735 1.35-74.57 1.54-75.03l.068-.167.18-.025 44.832-6.074.63 1.445a214.691 214.691 0 0113.947 127.517l-4.666 23.865 23.061 93.11-21.825 10.914-16.746-43.425-11.319 44.429z"
        fill="#2f2e41"
      />
      <path
        d="M354.008 300.31l-14.626-42.855c-9.092-16.012-3.325-30.228 3.114-39.333 6.954-9.833 7.372-15.347 7.464-15.408l.074-.049 19.216-.582 17.785 18.071c1.118-.437 10.568 22.85 9.767 24.02l12.42 40.153z"
        fill="#cbcbcb"
      />
      <path
        d="M472.434 307.722l-48.18-37.269-37.154-43.849-16.045 15.65 43.9 45.247 52.377 30.164a8.798 8.798 0 105.102-9.943z"
        fill="#9f616a"
      />
      <path
        d="M366.496 258.11l-13.425-19.073a17.497 17.497 0 0127.367-21.717l17.2 19.287z"
        fill="#cbcbcb"
      />
      <circle cx={357.382} cy={174.009} r={22.819} fill="#9f616a" />
      <path
        d="M380.585 162.433H344.35v-15.794c7.953-3.16 15.735-5.847 20.44 0a15.794 15.794 0 0115.794 15.794z"
        fill="#2f2e41"
      />
      <path
        d="M349.345 142.852c-33.198-.907-26.912 53.785-26.912 53.785s6.264.829 9.122 1.315l3.451-1.943 3.714 2.435c1.705.009 3.497-.024 5.354-.059l1.702-3.505 3.797 3.442c6.91.01 25.666.201 25.666.201s11.303-54.656-25.894-55.671z"
        fill="#2f2e41"
      />
      <path
        d="M618.182 568.43h-381a1 1 0 010-2h381a1 1 0 010 2z"
        fill="#cbcbcb"
      />
    </svg>
  );
}

export default HeroSvg;
